import { render, staticRenderFns } from "./ResourceCenterMain.vue?vue&type=template&id=a85d2368&scoped=true"
import script from "./ResourceCenterMain.vue?vue&type=script&lang=js"
export * from "./ResourceCenterMain.vue?vue&type=script&lang=js"
import style0 from "./ResourceCenterMain.vue?vue&type=style&index=0&id=a85d2368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85d2368",
  null
  
)

export default component.exports